import React from "react";
import { FiCheck, FiShield } from "react-icons/fi";
import { DEFAULT_PRIVACY_LABELS, PRIVACY_HELP_TEXT } from "../utils/privacyUtils";

const CheckIcon = FiCheck;

const DEFAULT_CHANNEL_LABELS = {
  website: "Website",
  newsletter: "Newsletter",
  socials: "Social media",
  promotionalMaterials: "Promotional materials",
  internalPublications: "Internal publications",
  localMedia: "Local media",
  videoRecordings: "Video recordings",
};

const PrivacyChannelRow = ({
  t,
  channelKey,
  labelKey,
  icon: Icon = FiShield,
  checked,
  onChange,
  separated,
}) => (
  <label
    className={`grid min-h-[3.65rem] cursor-pointer grid-cols-[2.65rem_minmax(0,1fr)_2.25rem] items-center gap-3 px-4 py-2.5 ${
      separated ? "border-t border-slate-200/80 dark:border-slate-700/80" : ""
    }`}
  >
    <span
      className={`flex h-10 w-10 items-center justify-center rounded-full transition ${
        checked
          ? "bg-emerald-600 text-white shadow-[0_0.45rem_0.9rem_rgba(5,150,105,0.22)]"
          : "bg-emerald-100/75 text-emerald-700 dark:bg-emerald-950/60 dark:text-emerald-300"
      }`}
      aria-hidden="true"
    >
      <Icon className="h-5 w-5" />
    </span>

    <span className="min-w-0">
      <span className="block text-[0.9rem] font-black leading-tight text-slate-950 dark:text-slate-50">
        {t(labelKey, {
          defaultValue:
            DEFAULT_CHANNEL_LABELS[channelKey] ||
            DEFAULT_PRIVACY_LABELS[channelKey] ||
            channelKey,
        })}
      </span>
      <span className="mt-0.5 block text-[0.72rem] font-semibold leading-snug text-slate-500 dark:text-slate-400">
        {t(`privacy.channel_help.${channelKey}`, {
          defaultValue: PRIVACY_HELP_TEXT[channelKey] || "",
        })}
      </span>
    </span>

    <span className="relative inline-flex h-9 w-9 items-center justify-center justify-self-end">
      <input
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        className="peer absolute inset-0 h-9 w-9 cursor-pointer opacity-0"
      />
      <span className="flex h-8 w-8 items-center justify-center rounded-lg border border-slate-300 bg-white text-white transition peer-checked:border-emerald-600 peer-checked:bg-emerald-600 dark:border-slate-600 dark:bg-slate-800">
        {checked ? <CheckIcon className="h-4 w-4" aria-hidden="true" /> : null}
      </span>
    </span>
  </label>
);

export default PrivacyChannelRow;
